module.exports = __webpack_public_path__ + "img/Logo-Bloom-Vorschaubild@2x.e5c99f03.png";